import { render, staticRenderFns } from "./SurveyTaskWindow.vue?vue&type=template&id=00428583&"
import script from "./SurveyTaskWindow.vue?vue&type=script&lang=js&"
export * from "./SurveyTaskWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports